import { useQuery } from 'react-query';
import { authFetch } from '../../../../CommonUtils/authFetch';
import { queryKeys } from './queryKeys';

export enum StatusDTO {
  NotConnected = 0,
  Success = 1,
  Broken = 2,
  IsDownloading = 3,
}

export const RISKALYZE = 'Riskalyze';

export interface IntegrationDTO {
  Label: string;
  LastUpdated: string;
  Name: string;
  Status: StatusDTO;
}

interface IntegrationResponseDTO {
  Integrations: IntegrationDTO[];
}

const fetchIntegrationsSettings = (): Promise<IntegrationResponseDTO> => {
  return authFetch('/Adviser/Settings/Integrations');
};

export const useIntegrationsSettingsQuery = () => {
  return useQuery(
    queryKeys.integrations(),

    () => fetchIntegrationsSettings(),

    {
      cacheTime: 0,
    },
  );
};
